import API from "@/constants/api";
import { AxiosResponse } from "axios";
import axiosUtil from "@/utils/axios.util";
import { UpdateProfile } from "@/interfaces/update-profile";
// import token from "@/static/JWT";

// interfaces
import { ProductData } from "@/interfaces/product-data.model";
import { CategoryData } from "@/interfaces/category-data.model";

// add category
async function addCategory(data: CategoryData): Promise<AxiosResponse> {
  const url = API.admin.addCategory;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.post(url, data, config);
}

// update category
async function updateCategory(
  id: string,
  data: CategoryData
): Promise<AxiosResponse> {
  const url = API.admin.updateCategory;
  const ID = id;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    params: {
      id: ID,
    },
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  const body = data;
  return axiosUtil.put(url, body, config);
}

// delete category
async function deleteCategory(id: string): Promise<AxiosResponse> {
  const url = API.admin.deleteCategory;
  const ID = id;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    params: {
      id: ID,
    },
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.delete(url, config);
}

// get products (by ID)
async function getProducts(id: any): Promise<AxiosResponse> {
  const url = API.admin.getProducts;
  const ID = id;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      category: ID,
    },
  };
  return axiosUtil.get(url, config);
}

// add product
async function addProduct(data: ProductData): Promise<AxiosResponse> {
  const url = API.admin.addProduct;
  const TOKEN = localStorage.getItem("picketAdmin");
  const DATA = data;
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.post(url, DATA, config);
}

// upload product image
async function uploadProductImage(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.uploadProductImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const ID = id;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: ID,
    },
  };
  return axiosUtil.post(url, FormData, config);
}

// upload product image
async function uploadProductDetailImages(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.uploadProductDetailImages;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const ID = id;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: ID,
    },
  };
  return axiosUtil.post(url, FormData, config);
}

// edit product
async function editProduct(payload: {
  id: string;
  data: ProductData;
}): Promise<AxiosResponse> {
  const url = API.admin.editProduct;
  const TOKEN = localStorage.getItem("picketAdmin");
  const ID = payload.id;
  const DATA = payload.data;
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      id: ID,
    },
  };
  return axiosUtil.put(url, DATA, config);
}

// delete product
async function deleteProduct(id: string): Promise<AxiosResponse> {
  const url = API.admin.deleteProduct;
  const TOKEN = localStorage.getItem("picketAdmin");
  const ID = id;
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      id: ID,
    },
  };
  return axiosUtil.delete(url, config);
}

// get product details
async function getProductDetails(id: string): Promise<AxiosResponse> {
  const url = API.admin.getProductDetails;
  const TOKEN = localStorage.getItem("picketAdmin");
  const ID = id;
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      id: ID,
    },
  };
  return axiosUtil.get(url, config);
}

// get all users list
async function getUsersList(): Promise<AxiosResponse> {
  const url = API.admin.getUsersList;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  return axiosUtil.get(url, config);
}

// edit user profile (by admin)
async function editUserProfile(
  id: string,
  data: UpdateProfile
): Promise<AxiosResponse> {
  const url = API.admin.editUserProfile;
  const TOKEN = localStorage.getItem("picketAdmin");
  const ID = id;
  const DATA = data;
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      user: ID,
    },
  };
  return axiosUtil.put(url, DATA, config);
}

// edit user avatar (by admin)
async function editUserAvatar(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.editUserAvatar;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const ID = id;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: ID,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

// user wallet charge
async function chargingTheUserWallet(
  amount: number,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.chargingTheUserWallet;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      id,
    },
  };
  const body = {
    amount,
  };
  return axiosUtil.put(url, body, config);
}

// get transactions list
async function getTransactionsList(): Promise<AxiosResponse> {
  const url = API.admin.getTransactionsList;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  return axiosUtil.get(url, config);
}

// get invoices list
async function getInvoicesList(): Promise<AxiosResponse> {
  const url = API.admin.getInvoicesList;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  return axiosUtil.get(url, config);
}

// accept invoice
async function acceptInvoice(id: string): Promise<AxiosResponse> {
  const url = API.admin.acceptInvoice;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      invoice: id,
    },
  };

  return axiosUtil.put(url, {}, config);
}

// end invoice
async function endInvoice(id: string): Promise<AxiosResponse> {
  const url = API.admin.endInvoice;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,

      invoice: id,
    },
  };

  return axiosUtil.put(url, {}, config);
}

// get all admins list
async function getAdminsList(): Promise<AxiosResponse> {
  const url = API.admin.getAdminsList;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  return axiosUtil.get(url, config);
}

// landing

// about us
async function updateAboutUsMainBanner(
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.aboutUs.updateMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function updateAboutUsContent(data: {
  title: string;
  text: string;
  language: string;
}): Promise<AxiosResponse> {
  const url = API.admin.landing.aboutUs.updateContent;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

async function updateContactUsContent(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.contactUs;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}
async function updateCertificatesContent(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.certificates;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function uploadCertificateImage(
  id: string,
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.uploadCertificateImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function submitCatalog(
  catologData: any,
): Promise<AxiosResponse> {
  const url = API.admin.landing.addNewCatalog;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = catologData;

  return axiosUtil.post(url, body, config);
}

async function uploadCatalogImage(
  id: string,
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.updateCatalogImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function deleteCatalog(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.deleteCatalog;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function uploadMajorShoppingMainBanner(
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.majorShopping.uploadMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function updateMajorShoppingContent(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.majorShopping.updateContent;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

async function updateHomePageMainBanner(
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.updateMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.post(url, FormData, config);
}

async function updateHomePageAboutUsMainBanner(
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.aboutUsMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function updateHomePageAboutUsContent(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.updateAboutUsContent;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

async function uploadStatueImage(formData: FormData): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.pushStatueImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.post(url, FormData, config);
}

async function getStatues(): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.getStatues;

  return axiosUtil.get(url);
}

async function deleteStatue(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.deleteStatue;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      statueid: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function deleteCategoryService(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.category.deleteCategoryService;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function uploadCategoryService(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.category.uploadCategoryService;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      category: id,
    },
  };
  return axiosUtil.post(url, FormData, config);
}

async function getServicesByCategory(category: string): Promise<AxiosResponse> {
  const url = API.admin.landing.category.getServicesByCategory;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      category: category,
    },
  };

  return axiosUtil.get(url, config);
}

async function updateStatueContent(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.homePage.updateStatueContent;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

// update aluminium category
async function updateAluminiumCategoryApi(data: {
  language: string;
  title: string;
}): Promise<AxiosResponse> {
  const url = API.admin.landing.category.updateAluminiumCategory;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

// update potlid category
async function updatePotlidCategoryApi(data: {
  language: string;
  title: string;
}): Promise<AxiosResponse> {
  const url = API.admin.landing.category.updatePotlidCategory;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

// landing category
async function createLandingCategory(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.category.createLandingCategory;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function uploadLandingCategoryImage(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.category.uploadLandingCategoryImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function uploadLandingCategoryBanner(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.category.uploadLandingCategoryBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function createLandingProduct(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.product.createLandingProduct;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function uploadLandingProductImage(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.product.uploadLandingProductImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function uploadLandingProductImages(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.product.uploadLandingProductImages;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const ID = id;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: ID,
    },
  };

  return axiosUtil.post(url, FormData, config);
}

async function getAllLandingCategories(): Promise<AxiosResponse> {
  const url = API.admin.landing.category.getAllLandingCategories;

  return axiosUtil.get(url);
}

async function createNewLandingMoreBox(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.moreBox.createMoreBox;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function uploadMoreBoxImage(
  formData: FormData,
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.moreBox.uploadMoreBoxImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function getMoreBoxes(): Promise<AxiosResponse> {
  const url = API.admin.landing.moreBox.getMoreBoxes;

  return axiosUtil.get(url);
}

async function getCertificates(): Promise<AxiosResponse> {
  const url = API.admin.landing.getCertificates;

  return axiosUtil.get(url);
}

async function getCatalogs(): Promise<AxiosResponse> {
  const url = API.admin.landing.getCatalogs;

  return axiosUtil.get(url);
}

async function deleteMoreBox(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.moreBox.deleteMoreBox;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function deleteLandingCategory(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.category.deleteLandingCategory;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function deleteCertificate(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.deleteCertificate;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      certificateid: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function editLandingCategoryImage(
  id: string,
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.category.editLandingCategoryImage;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, FormData, config);
}

async function getMainBanners(): Promise<AxiosResponse> {
  const url = API.admin.landing.mainBanners.getMainBanners;

  return axiosUtil.get(url);
}

async function deleteMainBanner(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.mainBanners.deleteMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");

  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      bannerid: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function createVideo(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.video.createVideo;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function getVideoHistory(): Promise<AxiosResponse> {
  const url = API.admin.landing.video.getVideoHistory;

  return axiosUtil.get(url);
}

async function deleteVideo(videoid: string): Promise<AxiosResponse> {
  const url = API.admin.landing.video.deleteVideo;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      videoid: videoid,
    },
  };

  return axiosUtil.put(url, "", config);
}

async function updateVideo(
  videoid: string,
  title: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.video.updateVideo;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      videoid: videoid,
    },
  };

  const body = {
    title: title,
  };

  return axiosUtil.put(url, body, config);
}

async function getSubCategories(): Promise<AxiosResponse> {
  const url = API.admin.landing.subCategories.getSubCategories;

  return axiosUtil.get(url);
}

async function getContactUs(): Promise<AxiosResponse> {
  const url = API.admin.landing.aboutUs.getContactUs;

  return axiosUtil.get(url);
}

async function getShopMainBanners(): Promise<AxiosResponse> {
  const url = API.admin.landing.shopMainBanners.getShopMainbanners;

  return axiosUtil.get(url);
}

async function createShopMainBanner(
  formData: FormData
): Promise<AxiosResponse> {
  const url = API.admin.landing.shopMainBanners.createShopMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const FormData = formData;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.post(url, FormData, config);
}

async function deleteShopMainBanner(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.shopMainBanners.deleteShopMainBanner;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };

  return axiosUtil.put(url, "", config);
}

async function createSubCategory(
  data: any,
  parentid: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.subCategories.createSubCategory;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      parentid: parentid,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function deleteSubCategory(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.subCategories.deleteCategory;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      subcategoryid: id,
    },
  };

  return axiosUtil.put(url, "", config);
}

async function createFaq(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.faq.createFaq;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function getFaqs(): Promise<AxiosResponse> {
  const url = API.admin.landing.faq.getFaqs;

  return axiosUtil.get(url);
}

async function deleteFaq(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.faq.deleteFaq;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      questionid: id,
    },
  };

  return axiosUtil.put(url, "", config);
}

async function getOffers(): Promise<AxiosResponse> {
  const url = API.admin.landing.offer.getLandingOffers;

  return axiosUtil.get(url);
}

async function createOffer(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.offer.createOffer;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function deleteOffer(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.offer.deleteOffer;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      offerid: id,
    },
  };

  return axiosUtil.put(url, "", config);
}

async function findLandingProductsByCategory(
  id: string
): Promise<AxiosResponse> {
  const url = API.admin.landing.findLandingProductsByCategory;

  const config = {
    headers: {
      category: id,
    },
  };

  return axiosUtil.get(url, config);
}

async function editLandingProduct(
  id: string,
  data: any
): Promise<AxiosResponse> {
  const url = API.admin.landing.product.editLandingProduct;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      productid: id,
    },
  };

  const body = data;

  return axiosUtil.put(url, body, config);
}

async function deleteLandingProduct(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.product.deleteLandingProduct;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      productid: id,
    },
  };

  return axiosUtil.put(url, "", config);
}

async function findLandingProductById(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.findLandingProductById;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      productid: id,
    },
  };

  return axiosUtil.get(url, config);
}

async function createFooterAddress(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.footerAddress.createFooterAddress;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function deleteFooterAddress(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.footerAddress.deleteFooterAddress;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function getFooterAddresses(): Promise<AxiosResponse> {
  const url = API.admin.landing.footerAddress.getFooterAddresses;

  return axiosUtil.get(url);
}

async function createFactoryAddress(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.factoryAddress.createFactoryAddress;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function deleteFactoryAddress(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.factoryAddress.deleteFactoryAddress;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function getFactoryAddresses(): Promise<AxiosResponse> {
  const url = API.admin.landing.factoryAddress.getFactoryAddresses;

  return axiosUtil.get(url);
}

async function createMajorShoppingInfo(data: any): Promise<AxiosResponse> {
  const url = API.admin.landing.majorShoppingInfo.createMajorShoppingInfo;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };

  const body = data;

  return axiosUtil.post(url, body, config);
}

async function getMajorShoppingInfos(): Promise<AxiosResponse> {
  const url = API.admin.landing.majorShoppingInfo.getMajorShoppingInfos;

  return axiosUtil.get(url);
}

async function deleteMajorShoppingInfo(id: string): Promise<AxiosResponse> {
  const url = API.admin.landing.majorShoppingInfo.deleteMajorShoppingInfo;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
      id: id,
    },
  };
  return axiosUtil.put(url, "", config);
}

async function getAllLandingData(): Promise<AxiosResponse> {
  const url = API.admin.landing.getAllLandingData;
  const TOKEN = localStorage.getItem("picketAdmin");
  const config = {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  };
  return axiosUtil.get(url, config);
}

export const adminService = {
  // category services
  addCategory,
  updateCategory,
  deleteCategory,

  // product services
  getProducts,
  addProduct,
  uploadProductImage,
  uploadProductDetailImages,
  editProduct,
  deleteProduct,
  getProductDetails,

  // user service
  getUsersList,
  editUserAvatar,
  editUserProfile,
  getTransactionsList,
  chargingTheUserWallet,

  // invoices
  getInvoicesList,
  acceptInvoice,
  endInvoice,

  // admins
  getAdminsList,
  getAllLandingData,

  // landing
  updateAboutUsMainBanner,
  updateAboutUsContent,
  updateContactUsContent,
  uploadMajorShoppingMainBanner,
  updateMajorShoppingContent,
  updateHomePageMainBanner,
  updateHomePageAboutUsMainBanner,
  updateHomePageAboutUsContent,
  uploadStatueImage,
  getStatues,
  deleteStatue,
  deleteCategoryService,
  uploadCategoryService,
  getServicesByCategory,
  updateStatueContent,
  updateAluminiumCategoryApi,
  updatePotlidCategoryApi,
  updateCertificatesContent,
  uploadCertificateImage,
  submitCatalog,
  uploadCatalogImage,
  deleteCatalog,
  createLandingCategory,
  uploadLandingCategoryImage,
  uploadLandingCategoryBanner,
  createLandingProduct,
  uploadLandingProductImage,
  uploadLandingProductImages,
  getAllLandingCategories,
  createNewLandingMoreBox,
  uploadMoreBoxImage,
  getCertificates,
  getCatalogs,
  deleteCertificate,
  getMoreBoxes,
  deleteMoreBox,
  deleteLandingCategory,
  editLandingCategoryImage,
  getMainBanners,
  deleteMainBanner,
  createVideo,
  getVideoHistory,
  deleteVideo,
  updateVideo,
  getSubCategories,
  getContactUs,
  getShopMainBanners,
  createShopMainBanner,
  createSubCategory,
  deleteSubCategory,
  deleteShopMainBanner,
  createFaq,
  getFaqs,
  deleteFaq,
  getOffers,
  deleteOffer,
  createOffer,
  findLandingProductsByCategory,
  findLandingProductById,
  editLandingProduct,
  deleteLandingProduct,
  createFooterAddress,
  getFooterAddresses,
  createFactoryAddress,
  getFactoryAddresses,
  deleteFooterAddress,
  deleteFactoryAddress,
  createMajorShoppingInfo,
  getMajorShoppingInfos,
  deleteMajorShoppingInfo,
};
